import {
    AfterViewInit,
    Component,
    Input,
    ViewEncapsulation
} from '@angular/core';
import { SubscriptionModel } from '../../../../shared/models/subscription.model';
import { CommonHttpService } from '../../../../shared/services/http.service';
import { AuthenticatedUserRepositoryService } from '../../../../payment/services/authenticated-user-repository.service';
import { ClientModel } from '../../../../shared/models/client.model';
import { Response } from '@angular/http';

@Component({
    selector: 'account-subscriptions-details-plan-details',
    templateUrl: './account.subscriptions.details.plan-details.component.html',
    styleUrls: ['./../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsPlanDetailsComponent implements AfterViewInit {
    @Input('subscription') subscription: SubscriptionModel;
    public client: ClientModel;
    public plan;

    constructor(
        protected http: CommonHttpService,
        protected authenticatedUserRepository: AuthenticatedUserRepositoryService
    ) { }

    ngOnInit () {
        this.client = this.authenticatedUserRepository.getUser();
    }

    ngAfterViewInit() {
        this.http.useAuth().get(
            `/account/clients/${this.client.id}`
            + `/subscriptions/${this.subscription.id}`
            + `/plan`
        ).subscribe((response: Response) => {
            this.plan = response.json().data;
        });
    }

    /**
     * Get extra fields and values from item's extra fields.
     **/
    public getExtraFields() {
        return Object
        .keys(this.plan.extra_fields)
        .map(slug => this.plan.extra_fields[slug]);
    }
}


// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/account/subscriptions/details/plan-details/account.subscriptions.details.plan-details.component.ts